import { tsValidateMustExist, tsValidateString } from '@nu-art/ts-common';
const Validator_ModifiableProps = {
    key: tsValidateString(),
    data: tsValidateMustExist,
};
const Validator_GeneratedProps = {};
export const DBDef_AppConfig = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'app-configs',
    entityName: 'AppConfig',
    frontend: {
        group: 'app',
        name: 'config'
    },
    backend: {
        name: 'app-configs'
    }
};
//# sourceMappingURL=db-def.js.map